import { i18n } from "@/setup/i18n-setup";
import { PropSelectGroup } from "./prop-select-group";
import { PropSelectItem } from "./prop-select-item";
import { getSalePropSelectGroup } from "./sale-to-prop-group";

export function getSaleInSaleLayoutPropSelectGroup():PropSelectGroup{
	let result = getSalePropSelectGroup();
	let item = new PropSelectItem(i18n.t("common.isDuplicate"), "IsDuplicate", "boolean");
	result.items.push(item);
	return result;
}